import { Row, Col, Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationArrow, faClock, faBook, faComment } from '@fortawesome/free-solid-svg-icons';

import './style.scss';

const Features = () => {
  return (
    <section id='features' className='text-center py-5'>
      <Container>
        <Row>
          <Col xs={12} className='section-title mb-5'>
            <div className='title-badge mb-3'>
              <span>Why Choose Jamlyf</span>
            </div>
            <h2 className="display-4 fw-bold mb-3">Platform Features</h2>
            <p className="lead">Discover the powerful features that make dining out effortless and enjoyable</p>
          </Col>
        </Row>
        <Row className="g-4 features-grid">
          <Col xs={12} sm={6} lg={3} className="mb-4">
            <div className="feature-card h-100">
              <div className="icon-wrapper">
                <FontAwesomeIcon icon={faLocationArrow} size="2x"/>
              </div>
              <h3 className="h4 mb-3">Restaurant Access</h3>
              <p className="feature-description">
                Discover and access countless verified restaurants, bars, lounges, and nightclubs 
                in your area. Find the perfect dining spot with our comprehensive directory.
              </p>
            </div>
          </Col>
          <Col xs={12} sm={6} lg={3} className="mb-4">
            <div className="feature-card h-100">
              <div className="icon-wrapper">
                <FontAwesomeIcon icon={faBook} size="2x"/>
              </div>
              <h3 className="h4 mb-3">Digital Menus</h3>
              <p className="feature-description">
                Browse complete restaurant menus, prices, and special offers before you visit or onsite. 
                Make informed dining decisions with detailed food descriptions and nutritional information.
              </p>
            </div>
          </Col>
          <Col xs={12} sm={6} lg={3} className="mb-4">
            <div className="feature-card h-100">
              <div className="icon-wrapper">
                <FontAwesomeIcon icon={faClock} size="2x"/>
              </div>
              <h3 className="h4 mb-3">Instant Service</h3>
              <p className="feature-description">
                Experience fast service from the moment you arrive. 
                Skip the wait for initial server engagement with instant ordering.
              </p>
            </div>
          </Col>
          <Col xs={12} sm={6} lg={3} className="mb-4">
            <div className="feature-card h-100">
              <div className="icon-wrapper">
                <FontAwesomeIcon icon={faComment} size="2x"/>
              </div>
              <h3 className="h4 mb-3">Feedback</h3>
              <p className="feature-description">
                Make your opinion count by giving ratings and review after your experience.
                Contribute to the reputation of spots and help other customers to make timely decisions
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default Features;
